import { Edit, SimpleForm } from "react-admin";
import { OrganForm } from "./OrganForm";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { useUpdateSubmit } from "../../forms";

const OrganEditForm = () => {
	const submit = useUpdateSubmit("organs", "Organ updated");

	return (
		<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
			<OrganForm />
		</SimpleForm>
	);
};

export const OrganEdit = () => (
	<Edit title="Update organ">
		<OrganEditForm />
	</Edit>
);
